<template>
  <section class="mt-3">
    <h2>Fasce di consumo</h2>
    <div v-for="(chart, i) in formattedCharts" :key="i" class="my-5">
      <h4 v-if="chart.title">{{ chart.title }}</h4>
      <b-row>
        <b-col>
          <div class="main-chart">
            <div class="main-chart--expchild">
              <vue-resizable :fit-parent="false" :active="['r', 'b']" :min-width="273"
                  :min-height="250"
                  @resize:end="onResizeEnd"
                  >
                <div class="resizable-content a">
                  <div
                  :style="{ 'height': minHeightDiv > chartWidthValue ? `${chartWidthValue}px` : `${minHeightDiv}px`, 'width': minHeightDiv > chartWidthValue ? `${chartWidthValue}px` : `${minHeightDiv}px` }">
                  <!-- pie chart -->  
                    <div id="pie" class="side-pie-chart"></div>
                  </div>
                </div>
              </vue-resizable>
            </div>
            <div class="main-chart--notexpchild">
              <!-- bar chart -->
              <div :style="{ height: checkChartHeight }" :ref="chart.id" :id="chart.id" />          
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-5">
              <b-col>
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th>F1 (kWh)</th>
                      <th>F2 (kWh)</th>
                      <th>F3 (kWh)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in tableData" :key="i">
                      <td style="text-transform: capitalize;">{{ row.date }}</td>
                      <td>{{ formatPrecision(row.f1, 4) }}</td>
                      <td>{{ formatPrecision(row.f2, 4) }}</td>
                        <td>{{ formatPrecision(row.f3, 4) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Totale</td>
                      <td>{{ formatPrecision(f1Tot) }}</td>
                      <td>{{ formatPrecision(f2Tot) }}</td>
                      <td>{{ formatPrecision(f3Tot) }}</td>
                    </tr>
                    <tr>
                        <td>%</td>
                        <td>{{ formatPrecision(f1Tot / total * 100, 3) }}%</td>
                        <td>{{ formatPrecision(f2Tot / total * 100, 3) }}%</td>
                        <td>{{ formatPrecision(f3Tot / total * 100, 3) }}%</td>
                      </tr>
                  </tfoot>
                </table>
              </b-col>
            </b-row>

    </div>
  </section>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import NeedUpdateMixin from "../../NeedUpdateMixin";
import utils from '../../../../utilsMixin';
import { debounce } from "lodash";
import { makeid } from '../../helpers';
import ChartTable from '../../Table';
import moment from 'moment';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import api from '@/services/api';

import { mapState, mapGetters, mapActions } from "vuex";
const formatDaily = "D MMM";
const formatMonthly = "MMM YYYY";

export default {
  name: "SlotsChart",
  mixins: [NeedUpdateMixin, utils],
  props: {
    badgeType: {
      type: String,
      required: false,
      default: "channels",
    },
    filter: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'bar',
    }
  },
  components: { ChartTable, vSelect },
  data() {
    return {
      newCalculatedData: undefined,
      dates: [],
      seriesColorIndex: 0,
      tooltipData: [],
      charts: [],
      isAggregateMode: false,
      measuresAggregateMode: ['sum', 'sum', 'sum', 'sum'],
      rangeAggregateModes: [],
      colors: this.$store.state.colors,
      series: [],
      mus: [],
      channels: [],
      dateFormat: {
        m: "MM/YYYY",
        w: "DD/MM/YYYY",
        d: "DD/MM/YYYY",
        "60": "DD/MM/YYYY",
      },
      previousPeriodDates: [],
      dateAxis: null,
      yAxis: {},
      data: null,
      truncatedAverageApplied: false,
      average: {
        enableTruncatedAverage: null,
        truncatedAverageExclude: 20,
        truncatedAverageMultiplier: 20
      },
      multiplier: 1,
      multiplierAggregateModes: [],
      tableData: [],
      tableFields: [
        { key: 'date', sortable: true, label: '' },
        { key: 'f1', sortable: true, label: 'F1' },
        { key: 'f2', sortable: true, label: 'F2' },
        { key: 'f3', sortable: true, label: 'F3' },
      ],
      sortBy: 'name',
      sortDesc: false,
      total: 0,
      parentHeight: 500,
      columnWidth: 339,
      chartWidth: 339,
      pieChart: null
    };
  },
  async mounted() {
    this.reload();
  },
  methods: {
    onResizeEnd(data) {
      console.log(data)
      if (data.eventName == "resize:end") {
        // this.parentHeight = data.height
        this.chartWidth = data.width

        this.pieChart.radius = am4core.percent(50);
        if (data.width > 300) {
          this.pieChart.radius = am4core.percent(60);
        }
        if (data.width > 400) {
          this.pieChart.radius = am4core.percent(70);
        }        
        if (data.width > 600) {
          this.pieChart.radius = am4core.percent(75);
        }
      }
    },
    channelName(channel) {
      let siteName = "";
      this.sites.forEach((site) => {
        site[this.badgeType].forEach((entity) => {
          if (this.compareEntityCode(entity, channel)) {
            channel = this.getName(entity);
            siteName = site.name;
          }
        });
      });
      return (this.sites.length > 1 ? " " + siteName : "");
    },
    getName(entity) {
      let name = null;
      switch (this.badgeType) {
        case "indicators":
          name = entity.formula ? entity.formula.name : "";
          break;
        case "channels":
          name = entity.name ? entity.name : "";
          break;
      }
      return name;
    },
    compareEntityCode(entity, channel) {
      let result = null;
      switch (this.badgeType) {
        case "indicators":
          result = entity.id === channel;
          break;
        case "channels":
          result = entity.code === channel;
          break;
      }
      return result;
    },
    async reload() {
      this.$store.commit('loading');

      const data = await this.getChartData();
      if (!data) {
        this.unload();
        this.$store.commit('stopLoading');
        return;
      }

      this.data = data;

      if (this.isAggregateMode) {
        this.isAggregateMode = false;
        this.$store.commit('stopLoading');
        return;
      }

      this.average.truncatedAverageExclude = this.data.truncatedAverageExclude * 100;
      this.average.truncatedAverageMultiplier = parseFloat(this.average.truncatedAverageMultiplier);
      this.average.enableTruncatedAverage = this.data.truncatedAverageApplied;

      this.truncatedAverageApplied = this.data.truncatedAverageApplied;
      this.average = { ... this.average };

      this.unload();
      const chartId = makeid();
      let chartItem = {
        id: chartId,
        toolbar: { open: false },
        showTable: false,
      };
      this.charts = [chartItem];

      this.$nextTick(() => {
        this.makeChart(chartItem, chartId, data, false);
        this.makePieChart(data);
      });

      this.$store.commit('stopLoading');
    },
    makePieChart(data) {
      try {
        let total = 0;
        let series = [];
        let sampling = this.filter.sampling;

        data.columns.forEach((c, i) => {
          if (i == 0)
            return
          let value = 0
          data.values.forEach(v => {
            value += v[i]
          })
          value = Number(value.toFixed(2))
          total += value
          const mu = data.mus[i - 1]
          series.push({
            name: `${c}`,
            unit: ` ${mu}`,
            value: Number(value)
          })
        });

        this.total = total

        /**
          { key: 'date', sortable: true, label: '' },
          { key: 'f1', sortable: true, label: 'F1' },
          { key: 'f2', sortable: true, label: 'F2' },
          { key: 'f3', sortable: true, label: 'F3' },
         */

        // Valorize table data
        this.tableData = data.values.map(item => {
          const format = sampling == 'd' ? formatDaily : formatMonthly
          return {
            date: moment(item[0]).format(format),
            f1: item[1],
            f2: item[2],
            f3: item[3],
            f1_p: item[1] / total * 100,
            f2_p: item[2] / total * 100,
            f3_p: item[3] / total * 100,
            mu: data.mus[0]
          }
        })

        // Push each mu into totalValue
        this.muList = [];
        this.totalValue = [];
        data.mus.forEach(item => {
          if (!this.muList.includes(item)) {
            this.muList.push(item);
          }
          if (!this.totalValue.find(value => value.mu == item)) {
            this.totalValue.push({ mu: item, value: 0 });
          }
        })

        // Valorize totalValue
        this.tableData.map(item => {
          this.totalValue.forEach(total => {
            if (total.mu.trim() == item.mu.trim()) {
              total.value += item.value;
            }
          })
          item.value = this.formatNum(item.value);
          return item;
        })
        this.totalValue.forEach(item => item.value = this.formatNum(item.value));

        // Create chart instance
        var chart = am4core.create('pie', am4charts.PieChart);
        chart.language.locale = am4lang_it_IT;
        chart.radius = am4core.percent(55);

        if (this.reportMode) {
          chart.fontSize = 10;
        }

        // Add data
        chart.data = series
        let colors = this.$store.state.colors;
        var colorSet = new am4core.ColorSet();
        colorSet.list = colors.map(function (color) {
          return new am4core.color(color);
        });

        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.labels.template.maxWidth = 130;
        pieSeries.labels.template.wrap = true;
        pieSeries.colors = colorSet;
        pieSeries.labels.template.fontSize = 11;
        pieSeries.alignLabels = false;

        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;

        pieSeries.ticks.template.disabled = false;
        // pieSeries.alignLabels = true;

        // tooltip settings
        pieSeries.tooltip.getFillFromObject = false;
        pieSeries.tooltip.autoTextColor = false;
        pieSeries.tooltip.label.fill = am4core.color("black");
        pieSeries.slices.template.tooltipText = "{name} [[{unit}]]: [bold] {value}";
        pieSeries.labels.template.text = "{name} {value.percent.formatNumber('#.0')}%";
        pieSeries.labels.template.fontSize = 14;
        var hs = pieSeries.slices.template.states.getKey("hover");
        hs.properties.scale = 1;

        chart.hiddenState.properties.radius = am4core.percent(0);

        this.pieChart = chart;
      } catch (error) {
        console.log(error)
      }
    },
    makeChart(chartItem, chartId, data, skipSeriesColor) {
      let chart = am4core.create(chartId, am4charts.XYChart);

      chart.language.locale = am4lang_it_IT;

      chart.numberFormatter.numberFormat = "#.0";

      chartItem.chart = chart;
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.cursorTooltipEnabled = false;
      dateAxis.groupData = false;

      dateAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
        if (target.dataItem.value) {
          let labelValue = target.dataItem.value;
          return this.getDateAxisLabelFormat(labelValue);
        }
      });

      let sampling = this.filter.sampling;
      if (sampling == '1' || sampling == '15' || sampling == '60') {
        // you can set grid intervals with below minGridDistance
        dateAxis.renderer.minGridDistance = 40;
      }

      dateAxis.renderer.minGridDistance = 40;
      dateAxis.renderer.cellStartLocation = 0.2
      dateAxis.renderer.cellEndLocation = 0.8
      dateAxis.renderer.labels.template.rotation = -45;
      dateAxis.renderer.labels.template.horizontalCenter = "right";
      dateAxis.renderer.labels.template.verticalCenter = "middle";

      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarX.parent = chart.bottomAxesContainer;
      chart.exporting.menu = new am4core.ExportMenu();

      chart.cursor = new am4charts.XYCursor();
      chart.legend = new am4charts.Legend();
      chart.legend.maxHeight = 150;
      chart.legend.scrollable = true;

      chart.series.clear();
      this.yAxis = {};
      let oppositeAxis = true;
      this.channels = [];
      data.mus.forEach((mu, index) => {
        if (!this.yAxis[mu]) {
          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.name = data.columns[index + 1];
          valueAxis.title.text = data.vectors[index] + "\xa0\xa0\xa0" + `[[${mu}]]`;  //`${data.columns[index + 1]}  [[${mu}]]`;
          valueAxis.title.fontWeight = 600;
          valueAxis.renderer.opposite = !oppositeAxis;
          valueAxis.fill = am4core.color(this.colors[index % this.colors.length]);
          oppositeAxis = !oppositeAxis;
          valueAxis.cursorTooltipEnabled = false;
          this.yAxis[mu] = valueAxis;
          valueAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
            if (target.dataItem.value) {
              let labelValue = Number(target.dataItem.value);
              if (labelValue > 100) {
                return labelValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
              } else if (labelValue < 1) {
                let num = labelValue.toFixed(4);
                return num.toString().replace('.', ",");
              } else {
                let num = labelValue.toFixed(2);
                return num.toString().replace('.', ",");
              }
            } else if (target.dataItem.value == 0) {
              return 0;
            }
          });
        }
        this.channels.push({
          name: data.columns[index + 1],
          mu,
        });
      });

      this.createSeries(data, chart, false, skipSeriesColor);

      let chartIndex = this.charts.findIndex(c => c.chartId == chartId);
      if (chartIndex >= 0) {
        this.charts[chartIndex].chart = chart;
      }
      if (this.isRecheckAggregateMode) {
        this.aggregateButton();
        this.isRecheckAggregateMode = false;
      }
    },
    createSeries(data, chart) {
      for (let index = 0; index < data.sources.length; index++) {
        let source = data.sources[index];

        let series = chart.series.push(new am4charts.ColumnSeries());
        let mu = data.mus[index];

        var seriesColor = this.colors[this.seriesColorIndex];
        this.seriesColorIndex += 1

        series.strokeWidth = 0;
        series.stroke = am4core.color(seriesColor);
        series.columns.template.fill = am4core.color(seriesColor);
        series.minBulletDistance = 15;
        series.stacked = true;

        let seriesName = '';
        let channel = source; //source.split(" ")[0];
        let siteName = this.channelName(channel);

        seriesName = data.columns[index + 1] + siteName;

        series.dataFields.valueY = source;

        series.meta = {
          siteName,
          source,
          cleanName: data.columns[index + 1],
        }
        series.name = seriesName;
        series.dataFields.dateX = "date";
        series.groupFields.valueY = "average";
        series.tooltip.label.propertyFields.fill = am4core.color('#FFFFFF');
        series.yAxis = this.yAxis[mu];
        series.connect = false;
        series.autoGapCount = 3;
        series.tooltip.getFillFromObject = false;
        series.tooltip.autoTextColor = false;
        series.adapter.add("tooltipText", (text, target) => {
          try {
            let tooltipData = target.tooltipDataItem.dataContext;
            let openValue = target.tooltipDataItem.values.valueY.value;
            let valueY = openValue ? openValue : tooltipData ? tooltipData.value : 0;
            let name = tooltipData && tooltipData.name ? tooltipData.name : false;
            var formattedValueY = valueY;

            if (isNaN(valueY)) {
              valueY = 0.000;
            }

            formattedValueY = this.formatPrecision(valueY, 4);
            let strokeColor = target.stroke.hex;
            let dateFormat = this.getTooltipFormat();
            var text = `${dateFormat}  \n [${strokeColor}]● [/] ${name} [[${tooltipData.unit}]]  [bold]${formattedValueY}[/]`
            if (tooltipData.comparePercentage) {
              let diff = Number(tooltipData.comparePercentage);
              if (this.filter.mode === 'INDICATORS') {
                if (diff > 0) {
                  text += " [red bold] ⬆" + diff + "%"
                } else {
                  text += " [green bold] ⬇" + diff + "%"
                }
              }
              else {
                if (tooltipData.source == 'channels') {
                  if (diff > 0) {
                    text += " [red bold] ⬆" + diff + "%"
                  } else {
                    text += " [green bold] ⬇" + diff + "%"
                  }
                } else if (tooltipData.source == 'parameters') {
                  if (diff > 0) {
                    text += " [green bold] ⬆" + diff + "%"
                  } else {
                    text += " [red bold] ⬇" + diff + "%"
                  }
                }
              }
            }
            return text;
          } catch (error) {
            console.log(error.message);
          }
        });

        series.tooltip.label.fill = am4core.color("black");
        var series_data = [];

        try {
          data.values.forEach((item, valueIndex) => {
            var valueYname = source;
            var dataItem = {};
            dataItem.unit = data.mus[index];
            // if (channels=EL)
            var checkChannels = this.filter.channels.find(ele => ele == source);
            var checkParameters = this.filter.parameters.find(ele => ele == source);
            // if(this.filters.channels)
            // dataItem.source = "channel"
            if (checkChannels == source) {
              dataItem.source = 'channels'
            } if (checkParameters == source) {
              dataItem.source = 'parameters'
            }

            dataItem.value = item[index + 1];

            dataItem.date = new Date(item[0]);
            dataItem.name = seriesName;

            dataItem[valueYname] = item[index + 1];
            series_data.push(dataItem);
          });
        } catch (error) {
          console.log(error)
        }
        series.data = series_data;
      }
    },
    async getChartData() {
      let params = _.cloneDeep(this.filter);
      if (this.average.enableTruncatedAverage === false) {
        this.filter.enableTruncatedAverage = false;
      }

      if (this.isIndicators) {
        params.indicators = [...params.channels];
        delete params.channels;
        let indicators = params.indicators ? params.indicators.length : true;
        if (!indicators) {
          return false;
        }
      }

      if (!this.isIndicators) {
        let channels = params.channels ? params.channels.length : true;
        let parameters = params.parameters ? params.parameters.length : true;
        let check = channels || parameters;
        let isPayload = !!check;
        if (!isPayload) {
          return false;
        }
      }

      params.sources = [];

      if (params.sampling && params.sampling == 'y') {
        params.compare = "no";
      }

      params.keepOriginalSourceName = false;

      let fromDate = null;
      let toDate = null;

      if (params.sampling == "y") {
        fromDate = params.fromYear + "-01-01";
        toDate = params.toYear + "-12-31";
      } else if (params.sampling == "m") {
        fromDate = moment(params.fromMonth, "MM-yyyy").format("yyyy-MM") + "-01";
        toDate = moment(params.toMonth, "MM-yyyy").format("yyyy-MM") + "-" + moment(params.toMonth, "MM-yyyy").daysInMonth();
      } else if (params.sampling == "d") {
        fromDate = params.fromDate;
        toDate = params.toDate;
      }

      const response = await api().post(`/dashboard/slots`, { channels: params.channels, fromDate, toDate, sampling: params.sampling });

      this.$store.commit("stopLoading");

      if (!response) {
        return false;
      }

      let data = response.data.data[0];

      return data;
    },
    getTooltipFormat(comparing) {
      let sampling = this.filter.sampling;

      if (sampling == "1" || sampling == "15" || sampling == "60") {
        return comparing ? '{previousDate.formatDate("MMM dd YYYY HH:mm - EEE")}' : '{date.formatDate("MMM dd YYYY HH:mm - EEE")}';
      }
      return comparing ? '{previousDate.formatDate("MMM dd YYYY - EEE")}' : '{date.formatDate("MMM dd YYYY - EEE")}';
    },
    formatNum(num) {
      let numArr = Number(num).toFixed(2).toString().split('.');

      if (numArr.length > 0) {
        var finalNum = numArr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'") + ',' + numArr[1]
      } else {
        var finalNum = numArr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
      return finalNum
    },
    getDateAxisLabelFormat(timestamp) {
      let formatMonthlyYearly = "d MMM yy";
      let format1Minute = "D MMM HH:mm";
      let formatDaily = "D MMM";
      let formatMonthly = "MMM YYYY";
      let formatYearly = "YYYY";
      let sampling = this.filter.sampling;

      if (sampling == 'd') {
        return moment(timestamp).format(formatDaily);
      } else if (sampling == 'm') {
        return moment(timestamp).format(formatMonthly);
      } else if (sampling == 'y') {
        return moment(timestamp).format(formatYearly);
      } else {
        const diff = moment(this.filter.toDate, "yyyy-MM-dd").diff(moment(this.filter.fromDate, "yyyy-MM-dd"), 'days');
        if (diff > 180) {
          return moment(timestamp).format(formatMonthlyYearly);
        }
        return moment(timestamp).format(format1Minute);
      }
    },
    initAggregationModeForRanges() {
      const newRangeAggregateModes = [];
      // Set default aggregate mode for each range
      this.getColumnNamesWithMeasure.forEach((rangeWithMeasure, index) => {
        const measureIndex = this.uniqueMeasures.findIndex((uniqueMeasure) => uniqueMeasure === rangeWithMeasure.measure);
        const aggregateMode = this.measuresAggregateMode[measureIndex];

        newRangeAggregateModes[index] = aggregateMode;
      });
      this.rangeAggregateModes = newRangeAggregateModes;
    },
    unload() {
      this.seriesColorIndex = 0;
      try {
        this.charts.forEach(chart => {
          chart.chart.dispose();
        });
        this.charts = [];
      } catch (err) {
        console.log(err)
      }
    },
    aggregateButton(chart, i) {
      if (!chart) {
        chart = this.charts[0];
      }
      this.rangeAggregateModes = [];
      if (this.filter.costs == true) {
        // this.filter.costs = false;
        this.isAggregateMode = true;
        this.initAggregationModeForRanges();
        this.createFxData(this.data);
        return;
      }

      if (this.isAggregateMode) {
        this.isAggregateMode = false;
        this.disposeAllSeries(chart)
        this.createSeries(this.data, chart.chart, false, false);
        return;
      }
      this.isAggregateMode = true;
      this.createFxData(this.data);
      this.initAggregationModeForRanges();
    },
    createFxData(data, dataType) {
      let chart = this.charts[0];

      if (dataType !== 'old') {
        this.disposeAllSeries(chart)
      }

      if (!data) {
        data = this.data;
      }

      try {
        const dataByMeasure = {
          columns: ["Data"],
          mus: [],
          sources: [],
          values: [],
        };

        let personlizedMeasure = _.cloneDeep(this.rangeAggregateModes);
        let mutedColumnNameWithMeasures = this.getColumnNamesWithMeasure.map((ele, i) => {
          ele.aggregateType = personlizedMeasure[i];
          return ele;
        });

        let seriesTobeCreated = {};
        this.uniqueMeasures.forEach((mu, umIndex) => {
          // let mu = kwh, now collect all data for kWH
          let aggregateType = this.measuresAggregateMode[umIndex];
          dataByMeasure.mus.push(mu);
          dataByMeasure.sources.push('ELE001_01' + umIndex);

          if (aggregateType == "mul") {
            dataByMeasure.sources = data.sources;
            dataByMeasure.mus = data.mus;
          }

          let seriesName = null;
          if (aggregateType == 'sum') {
            seriesName = "Somma - ";
          } else if (aggregateType == 'avg') {
            seriesName = "Media - ";
          } else if (aggregateType == 'mul') {
            seriesName = "Moltiplica - ";
          }
          let MuIndexes = [];

          // loop for each measure unit
          data.mus.forEach((dm, i) => {
            // check aggregate.type of column related to this dm
            let cAggre = mutedColumnNameWithMeasures.find(ele => ele.name == data.columns[i + 1]);
            // dm = measure unit, mu = measure unit
            if (dm == mu) {
              if (cAggre.aggregateType == undefined || (cAggre.aggregateType == aggregateType && aggregateType != 'mul')) {
                //measuresAggregateMode
                MuIndexes.push(Number(i));
                if (aggregateType == "mul") {
                  dataByMeasure.columns.push(data.columns[i + 1]);
                } else {
                  seriesName += data.columns[i + 1] + ',';
                }
              } else {
                //rangeAggregateModes
                let aggreType = cAggre.aggregateType == '' ? 'none' : cAggre.aggregateType;
                if (seriesTobeCreated[aggreType]) {
                  seriesTobeCreated[aggreType].push(cAggre);
                } else {
                  seriesTobeCreated[aggreType] = [cAggre];
                }
              }
            }
          });

          // ORIGINAL: seriesName = seriesName.replace(/.$/,")");
          seriesName = seriesName.replace(/.$/, "");
          data.values.forEach((value, nIndex) => {
            let totalValue = 0;
            // loop to set data.value in totalValue
            for (let i = 0; i < value.length; i++) {
              if (MuIndexes.includes(i)) {
                totalValue += value[i + 1]
              }
            }

            // ORIGNAL: const calculatedValue = aggregateType == 'sum' ? totalValue : totalValue / MuIndexes.length;
            let calculatedValue = null;
            if (aggregateType == "sum") {
              calculatedValue = totalValue;
            } else if (aggregateType == "avg") {
              calculatedValue = totalValue / MuIndexes.length;
            } else if (aggregateType == "mul") {
              let arrayValues = [
                value[0]
              ];
              for (let i = 1; i < value.length; i++) {
                arrayValues.push(value[i] * this.multiplier);
              }
              dataByMeasure.values.push(arrayValues);
            }
            if (aggregateType != "mul") {
              if (dataByMeasure.values[nIndex]) {
                dataByMeasure.values[nIndex].push(calculatedValue)
              } else {
                dataByMeasure.values.push([value[0], calculatedValue]);
              }
            }
          });

          if (aggregateType != "mul") {
            dataByMeasure.columns.push(seriesName);
          }
        });

        // to set up columns correctly
        if (seriesTobeCreated["mul"] && seriesTobeCreated["mul"].length > 1) {
          dataByMeasure.columns = ["Data"];
          seriesTobeCreated["mul"].forEach(item => {
            dataByMeasure.columns.push("Moltiplica - " + item.name);
          })
        } else if (seriesTobeCreated["mul"]) {
          let position = null;
          for (let i = 0; i < this.multiplierAggregateModes.length; i++) {
            if (this.multiplierAggregateModes[i]) {
              position = i;
            }
          }
          dataByMeasure.columns[position + 1] = "Moltiplica - " + data.columns[position + 1];
        }

        // to set up columns correctly
        if (seriesTobeCreated["none"] && seriesTobeCreated["none"].length > 1) {
          dataByMeasure.columns = ["Data"];
          seriesTobeCreated["none"].forEach(item => {
            dataByMeasure.columns.push("Nessuna - " + item.name);
          })
        } else if (seriesTobeCreated["none"]) {
          let position = null;
          data.columns.forEach((item, colIndex) => {
            if (item == seriesTobeCreated["none"][0].name) {
              position = colIndex;
            }
          })
          dataByMeasure.columns[position] = "Nessuna - " + data.columns[position];
        }

        if (seriesTobeCreated["sum"] || seriesTobeCreated["avg"] || seriesTobeCreated["mul"] || seriesTobeCreated["none"]) {
          dataByMeasure.mus = [];
          dataByMeasure.sources = [];
        }

        if (seriesTobeCreated["sum"] || seriesTobeCreated["avg"]) {
          dataByMeasure.values = [];
        }

        if (seriesTobeCreated != {}) {
          for (let key in seriesTobeCreated) {
            this.uniqueMeasures.forEach((mu, umIndex) => {
              if (key == "mul" || key == "none") {
                let position = null;
                for (let i = 0; i < seriesTobeCreated[key].length; i++) {
                  //to find position
                  data.columns.forEach((item, index) => {
                    if (seriesTobeCreated[key].length == 1) {
                      if (item == seriesTobeCreated[key][0].name) {
                        position = index;
                      }
                    } else {
                      if (item == seriesTobeCreated[key][i].name) {
                        position = index;
                      }
                    }
                  })

                  //to set up dataByMeasure.values once
                  if (dataByMeasure.values.length < 1) {
                    dataByMeasure.values = data.values;
                  }

                  if (key == "mul") {
                    data.values.forEach((value, dataVIndex) => {
                      dataByMeasure.values[dataVIndex][position] = value[position] * this.multiplierAggregateModes[position - 1];
                    });
                  } else {
                    data.values.forEach((value, dataVIndex) => {
                      dataByMeasure.values[dataVIndex][position] = value[position];
                    });
                  }
                  dataByMeasure.mus.push(mu);
                  dataByMeasure.sources.push(data.sources[position - 1]);
                }
              } else {
                let filteredSeries = seriesTobeCreated[key].filter(ele => ele.measure == mu);

                // here create a new series particularly for this measure and mu
                let meaMuSeriesName = "";
                if (key == 'sum') {
                  meaMuSeriesName = "Somma - ";
                } else if (key == 'avg') {
                  meaMuSeriesName = "Media - ";
                }

                if (filteredSeries.length) {
                  dataByMeasure.mus.push(mu);
                  dataByMeasure.sources.push('diffSeries' + key + mu + umIndex);
                }

                let MuIndexes = filteredSeries.map(e => e.indexInData);
                let joinedNames = filteredSeries.map(e => e.name).join();
                meaMuSeriesName += joinedNames

                data.values.forEach((value, nIndex) => {
                  let totalValue = 0;
                  for (let i = 0; i < value.length; i++) {
                    if (MuIndexes.includes(i)) {
                      totalValue += value[i]
                    }
                  }

                  var calculatedValue = key == 'sum' || key == 'none' ? totalValue : totalValue / MuIndexes.length;

                  if (dataByMeasure.values[nIndex]) {
                    dataByMeasure.values[nIndex].push(calculatedValue)
                  } else {
                    dataByMeasure.values.push([value[0], calculatedValue]);
                  }
                });

                let position = null;
                data.columns.forEach((item, colIndex) => {
                  if (item == seriesTobeCreated[key][0].name) {
                    position = colIndex;
                  }
                })

                if (filteredSeries.length) {
                  dataByMeasure.columns[position] = meaMuSeriesName;
                }
              }
            });
          }
        }

        if (dataType == 'new') {
          this.newCalculatedData = dataByMeasure
        } else if (dataType == 'old') {
          this.createSeries(this.newCalculatedData, chart.chart, false, dataByMeasure, false);
          this.createSeries(dataByMeasure, chart.chart, true, this.newCalculatedData, false);
        }

        if (!dataType) {
          this.createSeries(dataByMeasure, chart.chart, false, {}, false);
        }
      }
      catch (error) {
        console.log(error)
      }
    },
    disposeAllSeries(chart) {
      let l = Number(chart.chart.series.values.length);
      for (let i = 0; i < l; i++) {
        chart.chart.series.removeIndex(0).dispose();
      }
      this.seriesColorIndex = 0;
    },
  },
  computed: {
    ...mapState({
      sites: (state) => state.user.sites,
      user: (state) => state.user
    }),
    chartWidthValue() {
      return this.chartWidth
    },
    minHeightDiv() {
      return this.parentHeight
    },
    f1Tot() {
      return this.tableData.reduce((acc, item) => acc + item.f1, 0)
    },
    f2Tot() {
      return this.tableData.reduce((acc, item) => acc + item.f2, 0)
    },
    f3Tot() {
      return this.tableData.reduce((acc, item) => acc + item.f3, 0)
    },
    getColumnNamesWithMeasure() {
      return this.data.mus.map((ele, i) => {
        return {
          name: this.data.columns[i + 1],
          measure: ele,
          indexInData: i + 1
        }
      })
    },
    formattedCharts() {
      return this.charts;
    },
    uniqueMeasures() {
      return [...new Set(this.channels.map(item => item.mu))];
    },
    isIndicators() {
      return this.filter.mode === 'INDICATORS';
    },
    checkChartHeight() {
      if (this.filter.split) {
        return '350px'
      } else {
        return '500px'
      }
    }
  },
  watch: {
    filter(value, lastvalue) {
      if (value.channels.length != lastvalue.channels.length) {
        if (this.isAggregateMode) {
          this.isAggregateMode = false;
          this.isRecheckAggregateMode = true;
        }
      } else {
        this.isRecheckAggregateMode = false;
      }

      debounce(this.reload, 10)();
    },
    measuresAggregateMode() {
      this.isAggregateMode = false;
      this.aggregateButton();
    },
    multiplier() {
      this.isAggregateMode = false;
      this.aggregateButton();
    },
  },
  beforeDestroy() {
    this.unload();
  }
}
</script>
<style>

</style>
<style scoped>
.table thead th.light-head {
  background: #458cb2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/Slots.vue